// extracted by mini-css-extract-plugin
export default {"userForm":"UserForm_userForm__bdjR0","error":"UserForm_error__U5MYa","input":"UserForm_input__qGgJS"};